module.exports = __webpack_public_path__ + "img/ps-29.cd850617.jpg";